// source: pbtypes/vehicle/adsb_regulatory_manager/adsb_regulatory_manager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_adsb_regulatory_manager_airspace_volume_pb = require('../../../pbtypes/gen/adsb_regulatory_manager/airspace_volume_pb.js');
goog.object.extend(proto, pbtypes_gen_adsb_regulatory_manager_airspace_volume_pb);
var pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb = require('../../../pbtypes/gen/adsb_regulatory_manager/volume_dimensions_pb.js');
goog.object.extend(proto, pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb);
goog.exportSymbol('proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AdsbRegulatoryManagerState', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AdsbRespondAction', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AdsbRespondAction.Enum', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AirspaceVolumeState', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.AirspaceVolumeState.Enum', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.EncroachmentState', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.VehicleComplianceState', null, global);
goog.exportSymbol('proto.adsb_regulatory_manager.VehicleComplianceState.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adsb_regulatory_manager.AdsbRespondAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adsb_regulatory_manager.AdsbRespondAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adsb_regulatory_manager.AdsbRespondAction.displayName = 'proto.adsb_regulatory_manager.AdsbRespondAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adsb_regulatory_manager.AdsbRegulatoryManagerState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.displayName = 'proto.adsb_regulatory_manager.AdsbRegulatoryManagerState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.displayName = 'proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adsb_regulatory_manager.AirspaceVolumeState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adsb_regulatory_manager.AirspaceVolumeState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adsb_regulatory_manager.AirspaceVolumeState.displayName = 'proto.adsb_regulatory_manager.AirspaceVolumeState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adsb_regulatory_manager.EncroachmentState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adsb_regulatory_manager.EncroachmentState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adsb_regulatory_manager.EncroachmentState.displayName = 'proto.adsb_regulatory_manager.EncroachmentState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adsb_regulatory_manager.VehicleComplianceState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adsb_regulatory_manager.VehicleComplianceState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adsb_regulatory_manager.VehicleComplianceState.displayName = 'proto.adsb_regulatory_manager.VehicleComplianceState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.displayName = 'proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.displayName = 'proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.displayName = 'proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adsb_regulatory_manager.AdsbRespondAction.prototype.toObject = function(opt_includeInstance) {
  return proto.adsb_regulatory_manager.AdsbRespondAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adsb_regulatory_manager.AdsbRespondAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRespondAction.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adsb_regulatory_manager.AdsbRespondAction}
 */
proto.adsb_regulatory_manager.AdsbRespondAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adsb_regulatory_manager.AdsbRespondAction;
  return proto.adsb_regulatory_manager.AdsbRespondAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adsb_regulatory_manager.AdsbRespondAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adsb_regulatory_manager.AdsbRespondAction}
 */
proto.adsb_regulatory_manager.AdsbRespondAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adsb_regulatory_manager.AdsbRespondAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adsb_regulatory_manager.AdsbRespondAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adsb_regulatory_manager.AdsbRespondAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRespondAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.adsb_regulatory_manager.AdsbRespondAction.Enum = {
  NONE: 0,
  DESCEND: 1,
  LAND: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.prototype.toObject = function(opt_includeInstance) {
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adsb_regulatory_manager.AdsbRegulatoryManagerState;
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum = {
  UNKNOWN: 0,
  DISABLED: 1,
  IDLE: 2,
  RESPONDING: 3,
  WAITING_TO_CLEAR: 4,
  RECOVERING: 5,
  PILOT_IN_CONTROL: 6
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.prototype.toObject = function(opt_includeInstance) {
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode;
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum = {
  OFF: 0,
  ON: 1,
  INFO: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adsb_regulatory_manager.AirspaceVolumeState.prototype.toObject = function(opt_includeInstance) {
  return proto.adsb_regulatory_manager.AirspaceVolumeState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adsb_regulatory_manager.AirspaceVolumeState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AirspaceVolumeState.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adsb_regulatory_manager.AirspaceVolumeState}
 */
proto.adsb_regulatory_manager.AirspaceVolumeState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adsb_regulatory_manager.AirspaceVolumeState;
  return proto.adsb_regulatory_manager.AirspaceVolumeState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adsb_regulatory_manager.AirspaceVolumeState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adsb_regulatory_manager.AirspaceVolumeState}
 */
proto.adsb_regulatory_manager.AirspaceVolumeState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adsb_regulatory_manager.AirspaceVolumeState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adsb_regulatory_manager.AirspaceVolumeState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adsb_regulatory_manager.AirspaceVolumeState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AirspaceVolumeState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.adsb_regulatory_manager.AirspaceVolumeState.Enum = {
  NONE: 0,
  INSIDE: 1,
  INTERSECTING: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.toObject = function(opt_includeInstance) {
  return proto.adsb_regulatory_manager.EncroachmentState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adsb_regulatory_manager.EncroachmentState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.EncroachmentState.toObject = function(includeInstance, msg) {
  var f, obj = {
state: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
volume: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adsb_regulatory_manager.EncroachmentState}
 */
proto.adsb_regulatory_manager.EncroachmentState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adsb_regulatory_manager.EncroachmentState;
  return proto.adsb_regulatory_manager.EncroachmentState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adsb_regulatory_manager.EncroachmentState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adsb_regulatory_manager.EncroachmentState}
 */
proto.adsb_regulatory_manager.EncroachmentState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.adsb_regulatory_manager.AirspaceVolumeState.Enum} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 2:
      var value = /** @type {!proto.adsb_regulatory_manager.AirspaceVolume.Enum} */ (reader.readEnum());
      msg.setVolume(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adsb_regulatory_manager.EncroachmentState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adsb_regulatory_manager.EncroachmentState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.EncroachmentState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.adsb_regulatory_manager.AirspaceVolumeState.Enum} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {!proto.adsb_regulatory_manager.AirspaceVolume.Enum} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional AirspaceVolumeState.Enum state = 1;
 * @return {!proto.adsb_regulatory_manager.AirspaceVolumeState.Enum}
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.getState = function() {
  return /** @type {!proto.adsb_regulatory_manager.AirspaceVolumeState.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.AirspaceVolumeState.Enum} value
 * @return {!proto.adsb_regulatory_manager.EncroachmentState} returns this
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.setState = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.adsb_regulatory_manager.EncroachmentState} returns this
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.clearState = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.hasState = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AirspaceVolume.Enum volume = 2;
 * @return {!proto.adsb_regulatory_manager.AirspaceVolume.Enum}
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.getVolume = function() {
  return /** @type {!proto.adsb_regulatory_manager.AirspaceVolume.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.AirspaceVolume.Enum} value
 * @return {!proto.adsb_regulatory_manager.EncroachmentState} returns this
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.setVolume = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.adsb_regulatory_manager.EncroachmentState} returns this
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.clearVolume = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.EncroachmentState.prototype.hasVolume = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adsb_regulatory_manager.VehicleComplianceState.prototype.toObject = function(opt_includeInstance) {
  return proto.adsb_regulatory_manager.VehicleComplianceState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adsb_regulatory_manager.VehicleComplianceState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.VehicleComplianceState.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adsb_regulatory_manager.VehicleComplianceState}
 */
proto.adsb_regulatory_manager.VehicleComplianceState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adsb_regulatory_manager.VehicleComplianceState;
  return proto.adsb_regulatory_manager.VehicleComplianceState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adsb_regulatory_manager.VehicleComplianceState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adsb_regulatory_manager.VehicleComplianceState}
 */
proto.adsb_regulatory_manager.VehicleComplianceState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adsb_regulatory_manager.VehicleComplianceState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adsb_regulatory_manager.VehicleComplianceState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adsb_regulatory_manager.VehicleComplianceState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.VehicleComplianceState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.adsb_regulatory_manager.VehicleComplianceState.Enum = {
  UNKNOWN: 0,
  COMPLIANT: 1,
  NON_COMPLIANT_SD: 2,
  NON_COMPLIANT_NMAC: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
mode: jspb.Message.getFieldWithDefault(msg, 2, 0),
state: jspb.Message.getFieldWithDefault(msg, 3, 0),
complianceState: jspb.Message.getFieldWithDefault(msg, 4, 0),
currentRespondAction: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
currentPoseEncroachmentState: (f = msg.getCurrentPoseEncroachmentState()) && proto.adsb_regulatory_manager.EncroachmentState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus;
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 3:
      var value = /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 4:
      var value = /** @type {!proto.adsb_regulatory_manager.VehicleComplianceState.Enum} */ (reader.readEnum());
      msg.setComplianceState(value);
      break;
    case 6:
      var value = /** @type {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum} */ (reader.readEnum());
      msg.setCurrentRespondAction(value);
      break;
    case 7:
      var value = new proto.adsb_regulatory_manager.EncroachmentState;
      reader.readMessage(value,proto.adsb_regulatory_manager.EncroachmentState.deserializeBinaryFromReader);
      msg.setCurrentPoseEncroachmentState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getComplianceState();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getCurrentPoseEncroachmentState();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.adsb_regulatory_manager.EncroachmentState.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional AdsbRegulatoryManagerMode.Enum mode = 2;
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.getMode = function() {
  return /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional AdsbRegulatoryManagerState.Enum state = 3;
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.getState = function() {
  return /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional VehicleComplianceState.Enum compliance_state = 4;
 * @return {!proto.adsb_regulatory_manager.VehicleComplianceState.Enum}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.getComplianceState = function() {
  return /** @type {!proto.adsb_regulatory_manager.VehicleComplianceState.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.VehicleComplianceState.Enum} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.setComplianceState = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional AdsbRespondAction.Enum current_respond_action = 6;
 * @return {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.getCurrentRespondAction = function() {
  return /** @type {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.setCurrentRespondAction = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.clearCurrentRespondAction = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.hasCurrentRespondAction = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EncroachmentState current_pose_encroachment_state = 7;
 * @return {?proto.adsb_regulatory_manager.EncroachmentState}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.getCurrentPoseEncroachmentState = function() {
  return /** @type{?proto.adsb_regulatory_manager.EncroachmentState} */ (
    jspb.Message.getWrapperField(this, proto.adsb_regulatory_manager.EncroachmentState, 7));
};


/**
 * @param {?proto.adsb_regulatory_manager.EncroachmentState|undefined} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} returns this
*/
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.setCurrentPoseEncroachmentState = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.clearCurrentPoseEncroachmentState = function() {
  return this.setCurrentPoseEncroachmentState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerStatus.prototype.hasCurrentPoseEncroachmentState = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
mode: jspb.Message.getFieldWithDefault(msg, 2, 0),
state: jspb.Message.getFieldWithDefault(msg, 3, 0),
currentRespondAction: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus;
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 3:
      var value = /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 6:
      var value = /** @type {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum} */ (reader.readEnum());
      msg.setCurrentRespondAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional AdsbRegulatoryManagerMode.Enum mode = 2;
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.getMode = function() {
  return /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional AdsbRegulatoryManagerState.Enum state = 3;
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.getState = function() {
  return /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerState.Enum} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional AdsbRespondAction.Enum current_respond_action = 6;
 * @return {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.getCurrentRespondAction = function() {
  return /** @type {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.AdsbRespondAction.Enum} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.setCurrentRespondAction = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.clearCurrentRespondAction = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerMinimalStatus.prototype.hasCurrentRespondAction = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
filterDimensions: (f = msg.getFilterDimensions()) && pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.toObject(includeInstance, f),
alertDimensions: (f = msg.getAlertDimensions()) && pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.toObject(includeInstance, f),
sdBufferDimensions: (f = msg.getSdBufferDimensions()) && pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.toObject(includeInstance, f),
sdDimensions: (f = msg.getSdDimensions()) && pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.toObject(includeInstance, f),
nmacBufferDimensions: (f = msg.getNmacBufferDimensions()) && pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.toObject(includeInstance, f),
nmacDimensions: (f = msg.getNmacDimensions()) && pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.toObject(includeInstance, f),
aglComplianceAltitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings;
  return proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = new pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions;
      reader.readMessage(value,pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.deserializeBinaryFromReader);
      msg.setFilterDimensions(value);
      break;
    case 3:
      var value = new pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions;
      reader.readMessage(value,pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.deserializeBinaryFromReader);
      msg.setAlertDimensions(value);
      break;
    case 4:
      var value = new pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions;
      reader.readMessage(value,pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.deserializeBinaryFromReader);
      msg.setSdBufferDimensions(value);
      break;
    case 5:
      var value = new pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions;
      reader.readMessage(value,pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.deserializeBinaryFromReader);
      msg.setSdDimensions(value);
      break;
    case 6:
      var value = new pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions;
      reader.readMessage(value,pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.deserializeBinaryFromReader);
      msg.setNmacBufferDimensions(value);
      break;
    case 7:
      var value = new pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions;
      reader.readMessage(value,pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.deserializeBinaryFromReader);
      msg.setNmacDimensions(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAglComplianceAltitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getFilterDimensions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.serializeBinaryToWriter
    );
  }
  f = message.getAlertDimensions();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.serializeBinaryToWriter
    );
  }
  f = message.getSdBufferDimensions();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.serializeBinaryToWriter
    );
  }
  f = message.getSdDimensions();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.serializeBinaryToWriter
    );
  }
  f = message.getNmacBufferDimensions();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.serializeBinaryToWriter
    );
  }
  f = message.getNmacDimensions();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions.serializeBinaryToWriter
    );
  }
  f = message.getAglComplianceAltitude();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
};


/**
 * optional AdsbRegulatoryManagerMode.Enum mode = 1;
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.getMode = function() {
  return /** @type {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerMode.Enum} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional VolumeDimensions filter_dimensions = 2;
 * @return {?proto.adsb_regulatory_manager.VolumeDimensions}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.getFilterDimensions = function() {
  return /** @type{?proto.adsb_regulatory_manager.VolumeDimensions} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions, 2));
};


/**
 * @param {?proto.adsb_regulatory_manager.VolumeDimensions|undefined} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
*/
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.setFilterDimensions = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.clearFilterDimensions = function() {
  return this.setFilterDimensions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.hasFilterDimensions = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional VolumeDimensions alert_dimensions = 3;
 * @return {?proto.adsb_regulatory_manager.VolumeDimensions}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.getAlertDimensions = function() {
  return /** @type{?proto.adsb_regulatory_manager.VolumeDimensions} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions, 3));
};


/**
 * @param {?proto.adsb_regulatory_manager.VolumeDimensions|undefined} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
*/
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.setAlertDimensions = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.clearAlertDimensions = function() {
  return this.setAlertDimensions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.hasAlertDimensions = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional VolumeDimensions sd_buffer_dimensions = 4;
 * @return {?proto.adsb_regulatory_manager.VolumeDimensions}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.getSdBufferDimensions = function() {
  return /** @type{?proto.adsb_regulatory_manager.VolumeDimensions} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions, 4));
};


/**
 * @param {?proto.adsb_regulatory_manager.VolumeDimensions|undefined} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
*/
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.setSdBufferDimensions = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.clearSdBufferDimensions = function() {
  return this.setSdBufferDimensions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.hasSdBufferDimensions = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional VolumeDimensions sd_dimensions = 5;
 * @return {?proto.adsb_regulatory_manager.VolumeDimensions}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.getSdDimensions = function() {
  return /** @type{?proto.adsb_regulatory_manager.VolumeDimensions} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions, 5));
};


/**
 * @param {?proto.adsb_regulatory_manager.VolumeDimensions|undefined} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
*/
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.setSdDimensions = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.clearSdDimensions = function() {
  return this.setSdDimensions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.hasSdDimensions = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional VolumeDimensions nmac_buffer_dimensions = 6;
 * @return {?proto.adsb_regulatory_manager.VolumeDimensions}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.getNmacBufferDimensions = function() {
  return /** @type{?proto.adsb_regulatory_manager.VolumeDimensions} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions, 6));
};


/**
 * @param {?proto.adsb_regulatory_manager.VolumeDimensions|undefined} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
*/
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.setNmacBufferDimensions = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.clearNmacBufferDimensions = function() {
  return this.setNmacBufferDimensions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.hasNmacBufferDimensions = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional VolumeDimensions nmac_dimensions = 7;
 * @return {?proto.adsb_regulatory_manager.VolumeDimensions}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.getNmacDimensions = function() {
  return /** @type{?proto.adsb_regulatory_manager.VolumeDimensions} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_adsb_regulatory_manager_volume_dimensions_pb.VolumeDimensions, 7));
};


/**
 * @param {?proto.adsb_regulatory_manager.VolumeDimensions|undefined} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
*/
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.setNmacDimensions = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.clearNmacDimensions = function() {
  return this.setNmacDimensions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.hasNmacDimensions = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional float agl_compliance_altitude = 8;
 * @return {number}
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.getAglComplianceAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings} returns this
 */
proto.adsb_regulatory_manager.AdsbRegulatoryManagerSettings.prototype.setAglComplianceAltitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


goog.object.extend(exports, proto.adsb_regulatory_manager);
